import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface NewbieChestReward {
  gold: number;
  wood: number;
  stone: number;
  mana: number;
  // Inventory items (e.g. {"spd-30m": 1}). Empty {} at low Castle levels —
  // server only adds speedups from Castle Lvl 3 onwards.
  items: Record<string, number>;
}

export interface NewbieChestState {
  graduated: boolean;
  graduationLevel: number;
  castleLevel: number;
  cooldownSeconds: number;
  nextAvailableAt: string;
  available: boolean;
  reward: NewbieChestReward;
}

export interface NewbieChestClaim {
  claimedAt: string;
  nextAvailableAt: string;
  reward: NewbieChestReward;
  resources: { gold: number; wood: number; stone: number; mana: number };
}

export const newbieChestKeys = { state: ["newbie-chest"] as const };

export function useNewbieChest(enabled = true) {
  return useQuery({
    queryKey: newbieChestKeys.state,
    queryFn: async () => {
      const res = await api.get<NewbieChestState>("/newbie-chest");
      return res.data;
    },
    enabled,
    refetchInterval: 30_000,
  });
}

export function useClaimNewbieChest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await api.post<NewbieChestClaim>("/newbie-chest/claim");
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: newbieChestKeys.state });
      qc.invalidateQueries({ queryKey: ["castle"] });
    },
  });
}
